"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const malty_atoms_icon_wrapper_1 = require("@carlsberggroup/malty.atoms.icon-wrapper");
const react_1 = __importDefault(require("react"));
const MediaSound = (props) => (0, malty_atoms_icon_wrapper_1.IconWrapper)(props, react_1.default.createElement("g", { fillRule: "evenodd" },
    react_1.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
    react_1.default.createElement("path", { d: "M11.72 4.597A2 2 0 0115 6.133v11.73a2 2 0 01-3.28 1.537l-4.083-3.402H4a2 2 0 01-1.995-1.85L2 13.997v-4a2 2 0 012-2h3.636zM13 6.133L8.362 9.998H4v4h4.362L13 17.863zM17.5 8a4 4 0 110 8 1 1 0 01-.117-1.993L17.5 14a2 2 0 100-4 1 1 0 010-2z" })));
exports.default = MediaSound;
//# sourceMappingURL=index.js.map